/**
 * Routes that anonymous visitors are allowed to reach.
 *
 * The app otherwise assumes every page belongs to a signed-in user: `AuthProvider`
 * bootstraps a session on mount and the 401 interceptor redirects to the login screen.
 * Both consult this helper so a QR visitor is never bounced off a public share.
 */

export const PUBLIC_SHARE_PATH_PREFIX = '/share/';

export function isPublicSharePath(pathname: string): boolean {
  return pathname === '/share' || pathname.startsWith(PUBLIC_SHARE_PATH_PREFIX);
}

export function isCurrentPathPublic(): boolean {
  if (typeof window === 'undefined') return false;
  return isPublicSharePath(window.location.pathname);
}
